import React from "react";
import FoodoorLoading from "./../Assets/lottie/foodoor_loading.json";
import Lottie from "react-lottie";

const LoadingComponent = ({ data, subtitle, children }) => {
  return (
    <div
      className="text-center"
      style={{
        padding: "10px",
        width: "100%",
        height: "600px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Lottie
        isClickToPauseDisabled
        options={{
          loop: true,
          autoplay: true,
          animationData: FoodoorLoading,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
        height={50}
        width={50}
      />
      <br />
      <br />
      <h6 className="fs-15 mb-0">Loading ...</h6>
      <span />
    </div>
  );
};

export default LoadingComponent;
